import { extendObservable } from 'mobx'
import camelCase from 'lodash/camelCase'

import { configurationApi, employeeApi } from '@atheneum/api'

class DepartmentResponsibleUsersStore {
  constructor () {
    extendObservable(this, {
      entries: {},
      employees: [],
      loading: false,
      error: null
    })
  }

  getAll = async () => {
    this.loading = true

    const entries = await configurationApi.getAll()

    if (this.employees.length === 0) {
      const employees = await employeeApi.getAll()
      this.employees.replace(employees)
    }

    const entryKeys = [
      'BD_USER',
      'ERM_USER',
      'ACC_USER',
      'OPS_MANAGER',
      'BD_EMAIL',
      'ERM_EMAIL',
      'ACC_EMAIL',
      'CONTRACT_CONTROLLING_EMAIL',
      'NEW_PROJECT_EMAIL',
      'CLOSED_PROJECT_EMAIL',
      'OPS_MANAGMENT_EMAIL',
      'CONTROLLING_EMAIL'
    ]

    this.entries = entries
      .filter(entry => entryKeys.includes(entry.key))
      .reduce((acc, entry) => {
        acc[camelCase(entry.key)] = entry.value
        return acc
      }, {})

    this.loading = false
  }
}

export default DepartmentResponsibleUsersStore
